
var setCookie = function(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + "; " + expires + "; path=/";
}
  
var getCookie = function(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1);
      if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
    }
    return "";
}


$(document).ready(function () {

    $("#drive-safe-alert #close-alert").on('click', function(e) {
        e.preventDefault();
        $('#drive-safe-alert').hide();
        setCookie("alert-box", "closed", 1)
    });

    $('.blog-slider').slick({
        slidesToShow: 3,
        arrows: false,
        dots: false,
        responsive: [
            {
            breakpoint: 768,
                settings: {
                    arrows: true,
                    dots: true,
                    centerMode: false,
                    slidesToShow: 1
                }
            }
            
        ]
    });

    $('.open-menu').click(function (e) {
        e.preventDefault();

        $('#navbar').toggleClass('open');
        $('.nav-items #nav-arrows').toggleClass('open');
        $('.nav-items #nav-arrows').toggleClass('close');
    });

    $('#nav-toggle').click(function (e) {
        e.preventDefault();
        $('#navbar').toggleClass('open');
        $(this).hide();
        $('#nav-close').show();
    });

    $('#nav-close').click(function (e) {
        e.preventDefault();
        $('#navbar').toggleClass('open');
        $(this).hide();
        $('#nav-toggle').show();
    });

    $('#alert-icon').click(function (e) {
        e.preventDefault();
        $('#alert-text').toggle();
    });

    // insert youtube src
    $('.videoButton').click(function (e) {
        e.preventDefault();
        var theModal = $(this).data( 'bs-target' );
        var videoSRC = $(this).attr( 'data-video' );
        $(theModal+' iframe').attr('src', videoSRC);
    });

    // on close modal, remove video src
    $('.modal').on('hidden.bs.modal', function (e) {
        e.preventDefault();
        var modal_iframe = $(this).find('iframe');
        modal_iframe.removeAttr('src');
    })

    // insert photo src
    $('.photoButton').click(function (e) {
        e.preventDefault();
        var theModal = $(this).data( 'bs-target' );
        var photoSRC = $(this).attr( 'data-photo' );
        $(theModal+' img').attr('src', photoSRC);
    });

     $('.filter').click(function (e) {
        e.preventDefault();
        var cat = $(this).data( 'category' );
        
        if( $(this).is(':checked') ) {
            window.location.href = "/blog?cat="+cat;
            console.log('checked');
        }
        else {
            window.location.href = "/blog";
            console.log('not checked');
        }
        
    });

    $('#filter-to').change(function() {
        var fromDate = $('#filter-from').val();
        var toDate = $('#filter-to').val();
        if(fromDate && toDate) {
            window.location.href = "/blog?from="+fromDate+"&to="+toDate;
        }
    });
    $('#filter-from').change(function() {
        var fromDate = $('#filter-from').val();
        var toDate = $('#filter-to').val();
        if(fromDate && toDate) {
            window.location.href = "/blog?from="+fromDate+"&to="+toDate;
        }
    });


});